module.exports = __webpack_public_path__ + "static/media/schubergphilis.8f2299ed.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/schubergphilis.webp
// module id = 860
// module chunks = 0